import { useDeferredValue } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchHouseholdById } from 'api/households';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { accountQueryKeys } from 'queries/account-query-keys';

const useHouseholdId = () => {
    const { data: contact } = useCurrentContact();
    return useDeferredValue(contact.household_id);
};

const useCurrentContactHousehold = () => {
    const { accountId } = useCurrentAccount();
    const householdId = useHouseholdId() as number;

    return useSuspenseQuery({
        queryKey: accountQueryKeys.householdById(accountId, Number(householdId)),
        queryFn: () => fetchHouseholdById(accountId, householdId),
    });
};

const usePossibleCurrentContactHousehold = () => {
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();
    const householdId = useDeferredValue(contact.household_id);
    const hasHousehold = !!householdId;

    return useSuspenseQuery({
        queryKey: accountQueryKeys.householdById(accountId, Number(householdId)),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchHouseholdById(accountId, householdId as number),
                hasHousehold,
            ),
    });
};

export { useHouseholdId, useCurrentContactHousehold, usePossibleCurrentContactHousehold };
